// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/layoutEdit/layoutEdit.js#1 $
'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcLayoutEdit
* @element ANY
* @description
* # tcLayoutEdit
* Layout Editor
*/
angular.module('tcApp')
.directive('tcLayoutEdit', function() {
	
	return {
			templateUrl: 'template/layoutEdit/layoutEdit.html',
			restrict: 'E',
			scope: {
				data: '=?',
			},
			controller: 'LayoutEditCtrl',
		};
});
